import React from 'react';
import { Link } from 'react-router-dom';
import { contactInfo } from '../constants/contactInfo';

function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Contact Info</h3>
            <p>
              {contactInfo.addressLine1}
              <br />
              {contactInfo.addressLine2}
            </p>
            <p>
              Phone:{' '}
              <a href={contactInfo.phoneHref}>{contactInfo.phone}</a>
            </p>
            <p>
              Email:{' '}
              <a href={contactInfo.emailHref}>{contactInfo.email}</a>
            </p>
          </div>
          <div className="footer-section">
            <h3>Office Hours</h3>
            <p>Monday - Friday: 9:00 AM - 5:00 PM</p>
            <p>Weekend: By Appointment</p>
          </div>
          <div className="footer-section">
            <h3>Legal</h3>
            <p>
              <Link to="/privacy-policy">Privacy Policy</Link>
            </p>
            <p>
              <Link to="/terms-and-conditions">Terms of Service</Link>
            </p>
          </div>
        </div>
        <div className="footer-bottom">
          <p>
            &copy; {year} {contactInfo.copyrightName}. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
